/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is the healthy weight range calculated?`)
};

const es_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el rango de peso saludable?`)
};

const de_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird der gesunde Gewichtsbereich berechnet?`)
};

const nl_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt het gezonde gewichtsbereik berekend?`)
};

const fr_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la plage de poids santé est-elle calculée ?`)
};

const it_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come viene calcolato l'intervallo di peso sano?`)
};

const pt_br2_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a faixa de peso saudável é calculada?`)
};

const pt_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculado o intervalo de peso saudável?`)
};

const ja_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康的な体重範囲はどのように計算されますか？`)
};

const zh_hw_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`健康体重范围是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_faq1_q", locale)
	if (locale === "en") return en_hw_faq1_q(inputs)
	if (locale === "es") return es_hw_faq1_q(inputs)
	if (locale === "de") return de_hw_faq1_q(inputs)
	if (locale === "nl") return nl_hw_faq1_q(inputs)
	if (locale === "fr") return fr_hw_faq1_q(inputs)
	if (locale === "it") return it_hw_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_hw_faq1_q(inputs)
	if (locale === "pt") return pt_hw_faq1_q(inputs)
	if (locale === "ja") return ja_hw_faq1_q(inputs)
	return zh_hw_faq1_q(inputs)
};